import Vue from 'vue'
import Router from 'vue-router'
// import HelloWorld from '@/components/HelloWorld'
// import Home from '@/pages/home'

Vue.use(Router)

export default function({ Home, Stream }){
  return new Router({
    routes: [
      {
        path: '/',
        component: Home
      },
      {
        path: '/stream/:channelId/:streamId',
        component: Stream
      },
      {
        path: '/demo-for-native',
        component: resolve => require(['@/pages/demo-for-native'], resolve)
      }
    ]
  })
}



// WEBPACK FOOTER //
// ./src/router.js